import { ArrowLeft, ArrowRight } from "lucide-react";
import React from "react";

const PaginationControls = ({
  setCurrentPageNumber,
  currentPageNumber,
  itemsPerPage = 10,
  data,
}) => {
  return (
    <div className="flex space-x-1">
      <button
        className="bg-blue-500 hover:bg-blue-600  disabled:opacity-50 disabled:cursor-not-allowed text-xs text-white font-semibold px-2 border border-blue-500 hover:border-transparent rounded"
        onClick={() =>
          setCurrentPageNumber((prev) => (prev - 1 >= 1 ? prev - 1 : 1))
        }
        disabled={currentPageNumber === 1}
      >
        <ArrowLeft size={14} />
      </button>
      <span className=" bg-white text-blue-600 p-1 border border-blue-500 rounded px-2">
        {currentPageNumber}
      </span>
      <button
        onClick={() => setCurrentPageNumber((prev) => prev + 1)}
        disabled={data?.length < itemsPerPage}
        className="bg-blue-500 hover:bg-blue-600  disabled:opacity-50 disabled:cursor-not-allowed text-xs text-white font-semibold   px-2 border border-blue-500 hover:border-transparent rounded"
      >
        <ArrowRight size={14} />
      </button>{" "}
    </div>
  );
};

export default PaginationControls;
